import React from 'react'

import { StarRatingBadge } from '../../../../../product-page/components/StarRatingBadge'

export const getStarRating = (value: string, field: string, sectionLabel: string) => {
  return <StarRatingBadge value={value} field={field} sectionLabel={sectionLabel} />
}
